import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _DragHandleIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.92301 6.61543C9.19753 6.61543 10.2307 5.58223 10.2307 4.30772C10.2307 3.0332 9.19753 2 7.92301 2C6.6485 2 5.6153 3.0332 5.6153 4.30772C5.6153 5.58223 6.6485 6.61543 7.92301 6.61543ZM7.92301 14.3082C9.19753 14.3082 10.2307 13.275 10.2307 12.0004C10.2307 10.7259 9.19753 9.69273 7.92301 9.69273C6.6485 9.69273 5.6153 10.7259 5.6153 12.0004C5.6153 13.275 6.6485 14.3082 7.92301 14.3082ZM10.2307 19.6923C10.2307 20.9668 9.19753 22 7.92301 22C6.6485 22 5.6153 20.9668 5.6153 19.6923C5.6153 18.4178 6.6485 17.3846 7.92301 17.3846C9.19753 17.3846 10.2307 18.4178 10.2307 19.6923ZM15.6154 6.61543C16.8899 6.61543 17.9231 5.58223 17.9231 4.30772C17.9231 3.0332 16.8899 2 15.6154 2C14.3408 2 13.3076 3.0332 13.3076 4.30772C13.3076 5.58223 14.3408 6.61543 15.6154 6.61543ZM17.9231 12.0004C17.9231 13.275 16.8899 14.3082 15.6154 14.3082C14.3408 14.3082 13.3076 13.275 13.3076 12.0004C13.3076 10.7259 14.3408 9.69273 15.6154 9.69273C16.8899 9.69273 17.9231 10.7259 17.9231 12.0004ZM15.6154 22C16.8899 22 17.9231 20.9668 17.9231 19.6923C17.9231 18.4178 16.8899 17.3846 15.6154 17.3846C14.3408 17.3846 13.3076 18.4178 13.3076 19.6923C13.3076 20.9668 14.3408 22 15.6154 22Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const DragHandleIcon = assignWithoutSideEffects(_DragHandleIcon, {
  componentId: 'DragHandleIcon',
});

export default DragHandleIcon;
